import {deepMerge} from "grommet/utils";
import {
    Anchor,
    Box,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Footer,
    Grid,
    Grommet,
    grommet,
    Image, Nav,
    Page,
    Text
} from "grommet";
import {CircleInformation, Home, Info, Logout, Moon, ShareOption, Shop, Sun, Tag} from "grommet-icons";
import React, {useEffect, useState} from "react";
import AppBar from "../component/AppBar";
import CustomerDashboard from "../component/CustomerDashboard";
import {
    deleteRefreshToken,
    deleteToken, deleteUserID,
    getToken,
    getUserId,
    storeUserId
} from "../utils/token";
import axios from "axios";
import QRScanner from "../component/QRScanner";
import jwt_decode from "jwt-decode";
import api from "../utils/api";
import HeaderApp from "../component/HeaderApp";
import FooterApp from "../component/Footer/FooterApp";
import ShopList from "../component/ShopList";
import InstallPWA from "../component/InstallPWA";
import PWAPrompt from 'react-ios-pwa-prompt'

const Dashboard = () => {
    const [customerInfo, setCustomerInfo] = useState({});
    useEffect(() => {
        api.get(process.env.REACT_APP_BASE_API_URL + 'api/users/' + getUserId())
            .then(response => {
                setCustomerInfo(response.data);
                let info = response.data;
                //setStoreOffers(response.data.storeOffers);
                //setStores(response.data.stores);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const theme = deepMerge(grommet, {
        global: {
            "colors": {
                "brand": '#C01219',
                "focus": "#C01219",
            },
            "font": {
                "family": "Playfair Display",
                "size": "18px",
                "height": "20px",
            },
        },
    });
    const [dark, setDark] = useState(false);
    let template;
    let userRoles = customerInfo.roles;
    if (userRoles) {
        if (userRoles.includes("ROLE_STORE_USER")) {
            template = <QRScanner/>;
        } else {
            template = <CustomerDashboard/>;
        }
    }


    return (

        <Grommet theme={theme} full={true}>

            <Box fill>
                <Box flex={false} tag="header">
                    <AppBar>
                        <HeaderApp />
                    </AppBar>
                </Box>
                <Box flex overflow="auto" animation={"zoomIn"}>
                    <Grid columns="medium" gap="medium" pad={{bottom: "small"}}>
                        <Box pad="small" gap="small" width="medium">
                            {template}
                            {/*<Card background="light-1" border="dark">
                            <CardHeader pad="medium">
                                <Text weight={"bold"} color={"brand"}>
                                    Personal Info
                                </Text>
                            </CardHeader>
                            <CardBody pad="medium">
                                <Box direction={"row"} pad={"small"} gap={"medium"}>
                                    <Text alignSelf={"center"} wordBreak={"break-all"}>
                                        Matteo Domenici
                                    </Text>
                                    <Image
                                        fit="cover"
                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png"
                                    />

                                </Box>
                            </CardBody>
                            <CardFooter pad={{horizontal: "small"}} background="light-3">
                                <Button icon={<ShareOption color="plain"/>} hoverIndicator/>
                            </CardFooter>
                        </Card>*/}
                        </Box>
                        <Box pad="small" gap="small" width="medium">
                            <InstallPWA />
                            <PWAPrompt
                                promptOnVisit={1}
                                timesToShow={5}
                                copyTitle={"Aggiungi alla schermata Home"}
                                copyBody={"Aggiungi come App"}
                                copyShareButtonLabel={"1) Premi il bottone 'Share'"}
                                copyAddHomeButtonLabel={"2) Premi 'Aggiungi alla schermata Home'"}
                                copyClosePrompt="Chiudi"
                                permanentlyHideOnDismiss={false}/>
                        </Box>

                        {/*
            <Box pad="medium" gap="medium" width="large" direction={"row"}>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="cover"
                                src="https://cdn-icons-png.flaticon.com/512/657/657076.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Card Info
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="contain"
                                src="https://cdn-icons-png.flaticon.com/512/1507/1507683.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Scan QR code
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
            </Box>
        */}
                    </Grid>
                </Box>
                <Box flex={false} background="brand" >
                    <FooterApp />
                </Box>
            </Box>

        </Grommet>

    );
}

export default Dashboard;